import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { MyTeamActivity, MyTeamLogins, MyTeamNotifications } from '.';

const MyTeamSummary = () => {
  const { serverConfig } = useReduxState();

  return (
    <div className="summary">
      {!serverConfig.platformCompetenciesOnly && (
        <div className="notifications">
          <MyTeamNotifications />
        </div>
      )}

      <div className="activity">
        <MyTeamActivity />

        <MyTeamLogins />
      </div>

      <style jsx>{`
        .summary {
          display: flex;
          flex-direction: column;
          gap: 30px;
          margin-top: 10px;
        }
        .activity {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          flex-shrink: 1;
          gap: 50px;
        }
        @media (min-width: ${breakpoints.medium}px) {
          .summary {
            flex-direction: row-reverse;
          }
          .notifications {
            flex-shrink: 0;
            width: 340px;
          }
        }
      `}</style>
    </div>
  );
};

export default MyTeamSummary;
